/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { useDispatch, useSelector } from "react-redux";
import { changeMenu } from "../../../../../app/modules/Auth/redux/authReducer";
import { useHistory } from "react-router-dom";

export function LanguageSelectorDropdown() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { menuType } = useSelector((state) => state.auth);
  const {
    user: {
      accessToken,
      refreshToken,
      user: { user_role_id },
    },
  } = useSelector((state) => state.auth);

  const handleModule = (type) => {
    dispatch(changeMenu({ type: type }));
    if (type === "B2C") {
      return history.push("/dashboard/b2c");
    }
    if (type === "B2B") {
      return history.push("/dashboard/b2b");
    }
    if (type === "Wholesale") {
      return history.push("/dashboard/wholesale");
    }
  };
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-my-cart"
      >
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="language-panel-tooltip">Select Module</Tooltip>}
        >
          <div className="btn btn-dropdown btn-lg mr-1">{menuType}</div>
        </OverlayTrigger>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <ul className="navi navi-hover py-4">
          <li
            className={clsx("navi-item", {
              active: true,
            })}
            onClick={() => handleModule("B2C")}
          >
            <a className="navi-link">
              <span className="navi-text">B2C</span>
            </a>
          </li>
          {user_role_id != 19 && (
          <li
            className={clsx("navi-item", {
              active: true,
            })}
            onClick={() => handleModule("B2B")}
          >
            <a className="navi-link">
              <span className="navi-text">B2B</span>
            </a>
          </li>
          )}
          {user_role_id != 3 && user_role_id != 19 && (
            <li
              className={clsx("navi-item", {
                active: true,
              })}
              onClick={() => handleModule("Wholesale")}
            >
              <a className="navi-link">
                <span className="navi-text">Wholesale</span>
              </a>
            </li>
          )}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}
